import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Progress } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import apexLogo from '../assets/images/apex-logo.avif';

const ThankYouPage = () => {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const [timeLeft, setTimeLeft] = useState(5);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        const newProgress = prev + 2; // Increase by 2% every 100ms (100ms * 50 = 5000ms = 5s)
        if (newProgress >= 100) {
          clearInterval(interval);
          navigate('/');
        }
        return newProgress;
      });

      setTimeLeft(prev => {
        const newTimeLeft = Math.max(0, prev - 0.1);
        return newTimeLeft;
      });
    }, 100); // Update every 100ms for smooth animation

    return () => clearInterval(interval);
  }, [navigate]);

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#ffffff',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100vw',
        height: '100vh',
        overflow: 'hidden'
      }}
    >
      <Container className="h-100 d-flex justify-content-center align-items-center">
        <Row className="w-100">
          <Col lg={12}>
            <div className="thank-imag text-center">
              <img src={apexLogo} style={{ maxWidth: '300px' }} alt="ApexCXOs Logo" />
              <div className="my-5">
                <h3 className="text-center" style={{ fontSize: '40px' }}>
                  Thank You for contacting ApexCXOs.
                </h3>
              </div>
              
              <h5 className="text-center">
                <Link 
                  to="/" 
                  className="btn btn-partner position-relative overflow-hidden"
                  style={{
                    display: 'inline-block',
                    minWidth: '200px',
                    position: 'relative'
                  }}
                >
                  <span style={{ position: 'relative', zIndex: 2 }}>
                    Back to Home ({Math.ceil(timeLeft)}s)
                  </span>
                  <div
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      height: '100%',
                      width: `${progress}%`,
                      backgroundColor: 'rgba(220, 53, 69, 0.3)', // Red color with opacity
                      transition: 'width 0.1s ease',
                      zIndex: 1
                    }}
                  />
                </Link>
              </h5>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ThankYouPage;
